import { ContentService } from './services';
import config from 'config-base'

export default class ContentInteractor {
  public constructor(private contentService: ContentService, private stringHTMLBuilder: any) {}

  public async getFreeShippingModalContent(): Promise<string | undefined> {
    const { data: template } = await this.contentService.getFreeShippingModalTemplate();

    if (template) {
      const { data: FreeSHTotalRetail } = await this.contentService.getFreeSHTotalRetail();

      // Build string HTML
      const stringHTMLBuilder = new this.stringHTMLBuilder(template);
      stringHTMLBuilder.setDataByRegex([{ regex:/\$+\d+(?:\.\d{1,2})?/g, value: `$${FreeSHTotalRetail}`}]);
      if(config.brandCode === '2'){
        stringHTMLBuilder.setDynamicData([{pointer: 'Pyramyd AIR', value: 'Airgun Depot'}]);
      }
      const freeShippingModalContent = stringHTMLBuilder.getStringHTML();

      return freeShippingModalContent;
    }
  }

  public async getPageStyleCSS(): Promise<string | undefined> {
    const { data: Content } = await this.contentService.getPageStyleCSS();
    return Content;
  }

  public async get404Content(): Promise<string | undefined> {
    // Get 404 page template
    const { data: pageTemplate } = await this.contentService.get404Template();

    if (pageTemplate) {
      // Build string HTML
      const stringHTMLBuilder = new this.stringHTMLBuilder(pageTemplate);
      const string404Content = stringHTMLBuilder.getStringHTML();

      return string404Content;
    }
  }

  public async get404EditUrl(): Promise<string | undefined> {
    const { data: string404EditUrl } = await this.contentService.get404EditUrl();
    return string404EditUrl;
  }
}
